import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface MOCInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function MOCInternalControls({ onBack, setActiveSection, controlsListSection }: MOCInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Management Override of Controls"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}
